import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Partners = () => {
  const partnerData = [
    { id: 1, name: "Microsoft", logo: "/images/microsoft.webp" },
    { id: 2, name: "Dell", logo: "/images/dell.webp" },
    { id: 3, name: "Certiport", logo: "/images/Certiport.webp" },
    { id: 4, name: "CertNexus", logo: "/images/certnexus.webp" },
    { id: 5, name: "ETDP", logo: "/images/etdp.webp" },
    { id: 6, name: "MICT", logo: "/images/mict.webp" },
    { id: 8, name: "Proudly SA", logo: "/images/ProudlySA_Member_Logo 2.webp" },
    { id: 9, name: "Cisco", logo: "/images/Cisco2.webp" },
    { id: 10, name: "Hp", logo: "/images/hp2.webp" },
    { id: 11, name: "CompTIA", logo: "/images/comptia.webp" },
    { id: 12, name: "IBM", logo: "/images/IBM-business-partner.jpeg" },
    { id: 13, name: "QCTO", logo: "/images/qcto-2-03.webp" },
    { id: 14, name: "IRBA", logo: "/images/IRBA.png" }
    // Add more partners as needed
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 3000, // Speed of the slide transition in milliseconds
    slidesToShow: 5, // Number of slides to show at once
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0, // Adjusted speed for autoplay in milliseconds
    cssEase: 'linear',
    pauseOnHover: true, // Enable pausing on hover
    centerMode: false, // Disable center mode for consistent spacing
    responsive: [
      {
        breakpoint: 1024, // For tablets and desktops
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768, // For mobile devices
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480, // For very small screens
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  return (
    <div className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-8">
          Our <span className="text-customRed">Trusted</span> Partners
        </h2>

        <Slider {...settings} className="partner-carousel">
          {partnerData.map((partner) => (
            <div
              key={partner.id}
              className="flex justify-center px-4" // Adjusted padding for spacing
            >
              <div className="flex items-center justify-center">
                <img
                  src={partner.logo}
                  alt={`${partner.name} logo`}
                  className={`w-auto mx-auto ${
                    partner.name === "IRBA" ? "h-80 -my-32" : "h-20"
                  }`} // IRBA has extra transparent padding around its logo
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Partners;
